(function () {
  'use strict';

  if (window.__plfAiLoaderBound === true) return;
  window.__plfAiLoaderBound = true;

  function openMountedAssistant(root) {
    if (!window.PosterLeFiAssistant) return false;
    window.PosterLeFiAssistant.mount(root, { open: true });
    root.dataset.loaded = 'true';
    root.dataset.loading = 'false';
    return true;
  }

  function loadAssistant(root) {
    if (!root || openMountedAssistant(root) || root.dataset.loading === 'true') return;
    root.dataset.loading = 'true';
    const assistantScriptUrl = root.dataset.scriptUrl;
    const assistantStyleUrl = root.dataset.styleUrl;

    if (assistantStyleUrl && !document.querySelector(`link[href="${assistantStyleUrl}"]`)) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = assistantStyleUrl;
      document.head.appendChild(stylesheet);
    }

    const script = document.createElement('script');
    script.src = assistantScriptUrl;
    script.async = true;
    script.addEventListener('load', () => openMountedAssistant(root), { once: true });
    script.addEventListener('error', () => { root.dataset.loading = 'false'; }, { once: true });
    document.head.appendChild(script);
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('.plf-ai-launcher');
    if (!button) return;
    loadAssistant(button.closest('#plf-ai-assistant'));
  }, true);
})();
